import { useFragment } from "@apollo/client/react";
import {
  BidDecisionGroupFragment,
  BidDecisionGroupFragmentDoc,
} from "@/graphql/__generated__/graphql";

/**
 * Custom hook to retrieve a BidDecisionGroup's data from the cache.
 *
 * This hook uses the `useFragment` hook from Apollo Client to automatically
 * subscribe to changes in the BidDecisionGroup data.
 *
 * @param {{string}} {id} - The BidDecision from which to retrieve the data.
 * @returns {BidDecisionGroupFragment | undefined} - The BidDecisionGroup data or undefined if not available.
 *
 * @example
 * const bidDecisionGroup = useBidDecisionGroupData("1");
 *
 */
export const useBidDecisionGroupData = ({ id }: {id: string }): BidDecisionGroupFragment | undefined => {
  const { data } = useFragment({
    fragment: BidDecisionGroupFragmentDoc,
    from: {
      __typename: "BidDecisionGroup",
      _id: id,
    }
  });

  return data as BidDecisionGroupFragment | undefined;
};
